export const content = {
  error: 'Technische Fehlermeldung anzeigen',
  validationError: 'Fachliche Fehlermeldung:'
}
